import SearchResultsDesktopList from './search-results-desktop-list';
import SearchResultsMobileList from './search-results-mobile-list';
import forDevice from '../../hoc/for-device';

const SearchResultsList = forDevice(SearchResultsMobileList, SearchResultsDesktopList);
export default SearchResultsList;



// WEBPACK FOOTER //
// ./app/components/search-results-list/search-results-list.js